import React from 'react';
// import NavigationHeader from '../../components/navigationHeader';
// import BreadCrumb from '../../components/breadCrumb';
// import {CopyRightsFooter} from '../../components/copyrights';
import { getApi, postUIlogs, postRecentSearch, getMetadatas } from "../../utils/event_handling";
import $ from 'jquery';
// import ErrorHandler from '../../components/error_500';
// import BasicPortlet from '../../components/basicPortlet';
import DiscoverForm from './discoverForm';
import { connect } from "react-redux";
import Autosuggest from 'react-autosuggest';
import './react-autosuggest.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faServer, faDatabase, faTag } from '@fortawesome/free-solid-svg-icons';
import { faLayerGroup, faExclamation, faCodeBranch } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import {
  addRecentHistory,
  storeDiscoverPageDataForDataSrc
} from "../../redux/actions";
import RcTooltip from 'rc-tooltip';
//import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import { createBrowserHistory } from "history";
import { Scrollbars } from 'react-custom-scrollbars';
import { checkSessionForRedirection } from "../../utils/common_utils";
import { SKIP_SUGGESTION_RENDER } from "../../utils/constant";
import {
  // normalizeAttributeName,
  // METADATA_MAP_KEY_SEPARATOR,
  // METADATA_MAP_VALUE_SEPARATOR,
  normalizeChildDatasetName
} from '../../utils/attribute_name_utils';
import { getLastProcessing } from "../../utils/dataProfileEventHandling";
import { logoutPageRedirect } from "../../utils/common_utils";
import { Modal } from 'react-bootstrap';
import { prefetchRecentHistory} from "../../utils/dataFetch";
import store from "../../redux/store";

const colors = ['#FA4616', '#00c7d4', '#ffc700', '#4d9ff9', '#915cff', '#ff6c7c'];
var totalSearchList = 0;
const formatMultiSection = (searchStr, data,envId) => {

  const inputValue = searchStr.trim().toLowerCase();
  const selectedEnvId = envId;

  let environment = data.filter(value => {
    return (
      value.type === "Environment" &&
      value.name.toLowerCase().includes(inputValue) &&
      (!selectedEnvId || value.envId === selectedEnvId) 
    );
  });

  let datasource = data.filter(value => {
    return (
      value.type === "Datasource" &&
      value.name.toLowerCase().includes(inputValue) &&
      (!selectedEnvId || value.envId === selectedEnvId) 
    );
  });

  let dataset = data.filter(value => {
    return (
      value.type === "Dataset" &&
      value.name.toLowerCase().includes(inputValue) &&
      (!selectedEnvId || value.envId === selectedEnvId) 
    );
  });

  let attribute = data.filter(value => {
    return (
      value.type === "Attribute" &&
      value.name.toLowerCase().includes(inputValue) &&
      (!selectedEnvId || value.envId === selectedEnvId) 
    );
  });

  let recentSearch = [];
  if (searchStr.trim() === "") {
    recentSearch = data
      .filter(value =>
        value.type === "Recent" &&
        (!selectedEnvId || value.envId === selectedEnvId) 
      )
      .map(value => ({
        ...value,
        envId: selectedEnvId
      }));
  }

  let envObj = {
    type: "Environment",
    results: environment
  };

  let datasourceObj = {
    type: "Datasource",
    results: datasource
  };

  let datasetObj = {
    type: "Dataset",
    results: dataset
  };

  let attributeObj = {
    type: "Attribute",
    results: attribute
  };

  let recentSearchObj = {
    type: "Recent",
    results: recentSearch
  };

  let suggestions = [];

  if (recentSearchObj.results.length > 0) {
    suggestions.push(recentSearchObj);
  }

  if (envObj.results.length > 0) {
    suggestions.push(envObj);
  }

  if (datasourceObj.results.length > 0) {
    suggestions.push(datasourceObj);
  }

  if (datasetObj.results.length > 0) {
    suggestions.push(datasetObj);
  }

  if (attributeObj.results.length > 0) {
    suggestions.push(attributeObj);
  }

  totalSearchList = envObj.results.length + datasourceObj.results.length + datasetObj.results.length + attributeObj.results.length;
  return suggestions;
};


$("body").on("click", ".btn-clear", function () {
  $(".qd_search-box").removeClass("has-btn-close")
});

$("body").on("keyup", ".react-autosuggest__input", function () {
  if ($(this).val() !== "") {
    $(".qd_search-box").addClass("has-btn-close")

  } else {
    $(".qd_search-box").removeClass("has-btn-close")
    //$(".qd_search-box").removeClass("is-focused");
    $(".qd_search-box").removeClass("ad-filter-open");
    let countId = document.getElementById(".filter-count")
    if (!countId) {
      $("#btn-filter").removeClass("active");
    }
  }
  $(".filter-count").hide();
  $("#btn-filter").removeClass("active");
  $(".qd_search-box").removeClass("ad-filter-open");
  $(".qd_search-box").addClass("is-focused");

});

$(document).on("click", ".datalink", function (e) {
  if (document.getElementById($(this).attr("data-link")) !== null) {
    document.getElementById($(this).attr("data-link")).scrollIntoView();
  }
});


function shouldRenderSuggestions(value, reason) {
  if (SKIP_SUGGESTION_RENDER.includes(reason)) {
    return false;
  }

  return value.trim().length > 2;
}


function renderSuggestionsContainer({ containerProps, children, query }) {
 
  if (children === null && query === "") {
    return null;
  }
 
  if (children === null && query !== "") {
    return (<div {...containerProps}>
      <div className="row row-sm">
        <div className="col-md-6">
          <h4 className="qd_autosuggest-title">Environment</h4>
          <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
        </div>
        <div className="col-md-6">
          <h4 className="qd_autosuggest-title">Datasource</h4>
          <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
        </div>
        <div className="col-md-6">
          <h4 className="qd_autosuggest-title">Dataset</h4>
          <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
        </div>
        <div className="col-md-6">
          <h4 className="qd_autosuggest-title">Attribute</h4>
          <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
        </div>
      </div>
    </div>)
  }

  // Children is not null. Query string is empty
  if (query.trim() === "") {
    let checkRecent = children[0].props.children[0].props.section.results.filter(x => x.type === "Recent")
    if (checkRecent.length === 0) {
      return ""
    }
  }

  // Children is not null. Query string is also not empty
  let recentFlag = "";
  let environmentFlag = "";
  let datasourceFlag = "";
  let datasetFlag = "";
  let attributeFlag = "";

  let environmentFlaglen = 0;
  let datasourceFlaglen = 0;
  let datasetFlaglen = 0;
  let attributeFlaglen = 0;

  let data = this.props.watchListMapping;
children.map((item, i) => {
  const results = item.props.children[0].props.section.results;
  const type = results[0]?.type;
  const selectedEnvId = this.props.selectedEnvId;

  if (!results || results.length === 0) return null;

  // Filter by envId
  const filteredByEnv = results.filter(res => res.envId === selectedEnvId);

  if (type === "Environment") {
    if (filteredByEnv.length > 0) {
      environmentFlag = i;
      environmentFlaglen = filteredByEnv.length > 6 ? 168 : 28 * filteredByEnv.length;
    }
  }

  if (type === "Datasource") {
    if (filteredByEnv.length > 0) {
      datasourceFlag = i;
      datasourceFlaglen = filteredByEnv.length > 6 ? 168 : 28 * filteredByEnv.length;
    }
  }

  if (type === "Dataset") {
    if (filteredByEnv.length > 0) {
      datasetFlag = i;
      datasetFlaglen = filteredByEnv.length;

      filteredByEnv.forEach(dataset => {
        if (data !== undefined) {
          Object.keys(data).forEach(uniqueKey => {
            if (data[uniqueKey]['metadata_ids'].includes(dataset.id)) {
              datasetFlaglen += 1;
            }
          });
        }
      });

      datasetFlaglen = datasetFlaglen > 6 ? 168 : 28 * datasetFlaglen;
    }
  }

  if (type === "Attribute") {
    if (filteredByEnv.length > 0) {
      attributeFlag = i;
      attributeFlaglen = filteredByEnv.length;

      filteredByEnv.forEach(attribute => {
        if (data !== undefined) {
          Object.keys(data).forEach(uniqueKey => {
            if (data[uniqueKey]['metadata_ids'].includes(attribute.id)) {
              attributeFlaglen += 1;
            }
          });
        }
      });

      attributeFlaglen = attributeFlaglen > 6 ? 168 : 28 * attributeFlaglen;
    }
  }

  return null;
});

  $(".qd_search-box").removeClass("ad-filter-open");
  $(".qd_search-box").addClass("is-focused");

  return (
    <div {...containerProps}>
      <div className="row row-sm">
        {recentFlag !== "" && query === "" ? <div className="col-md-12">
          <h4 className="qd_autosuggest-title">Recent Searches:</h4>
          <div>{children[recentFlag]}</div>
        </div> : ""}
        {query !== "" ? <><div className="col-md-6">
          <h4 className="qd_autosuggest-title">Environment</h4>

          {environmentFlag !== "" ? (
            <Scrollbars style={{ height: environmentFlaglen }} className="custom-scrollbar"
              autoHeightMin={0}
              autoHeightMax={200}
              thumbMinSize={30}
              universal={true}>
              <div style={{ paddingRight: 5 }}>{children[environmentFlag]}</div>
            </Scrollbars>
          ) : (
            <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
          )}

        </div>
          <div className="col-md-6">
            <hr className="d-block d-sm-none" />
            <h4 className="qd_autosuggest-title">Datasource</h4>

            {datasourceFlag !== "" ? (
              <Scrollbars style={{ height: datasourceFlaglen }} className="custom-scrollbar"
                autoHeightMin={0}
                autoHeightMax={200}
                thumbMinSize={30}
                universal={true}>
                <div style={{ paddingRight: 5 }} >{children[datasourceFlag]}</div>
              </Scrollbars>
            ) : (
              <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
            )}

          </div>
          <div className="col-md-6">
            <hr />
            <h4 className="qd_autosuggest-title">Dataset</h4>


            {datasetFlag !== "" ? (
              <Scrollbars style={{ height: datasetFlaglen }} className="custom-scrollbar"
                autoHeightMin={0}
                autoHeightMax={200}
                thumbMinSize={30}
                universal={true}>
                <div style={{ paddingRight: 5 }}>{children[datasetFlag]}</div>
              </Scrollbars>
            ) : (
              <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
            )}

          </div>
          <div className="col-md-6">
            <hr />
            <h4 className="qd_autosuggest-title">Attribute</h4>

            {attributeFlag !== "" ? (
              <Scrollbars style={{ height: attributeFlaglen }} className="custom-scrollbar"
                autoHeightMin={0}
                autoHeightMax={200}
                thumbMinSize={30}
                universal={true}>
                <div style={{ paddingRight: 5 }}>{children[attributeFlag]}</div>
              </Scrollbars>
            ) : (
              <p className="no-search-result"><FontAwesomeIcon icon={faExclamation} />No results were found</p>
            )}

          </div>
          <div className="col-md-12">
            <hr />
            <p className="search-result__count"><strong>{totalSearchList}</strong> Search Results</p>
          </div></> : ""}
      </div>

    </div>
  );

}



//const getSuggestions = (value,autoCompleteData) => {
//  const inputValue = value.trim().toLowerCase();
//  const inputLength = inputValue.length;
//
//  return inputLength === 0 ? [] : autoCompleteData.filter(lang =>
//    lang.name.toLowerCase().slice(0, inputLength) === inputValue
//  );
//};



const renderSectionTitle = section => {
  // return (
  //   // <div style={{ display: "flex", alignItems: "flex-end" }}>
  //   //   <div style={{ marginRight: 8 }}>
  //   //   </div>
  //   //   <strong style={{ color: "#1D2C4C" }}><b>{section.type}</b></strong>
  //   // </div>
  //   // <div>
  //   //   <h4>{section.type}</h4>
  //   // </div>
  // );

};



// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name;

// Use your imagination to render suggestions.
//const renderSuggestion1 = suggestion => (
//  <div>
// {suggestion.name}
//  </div>
//);

const getSectionSuggestions = section => {
  return section.results;
};

let openflag = false;
$(document).on('click', function (e) {
  var container = $(".qd_search-filter-form");
  var btnfilter = $("#btn-filter");
  if ((!$(e.target).closest(container).length) && (!$(e.target).closest(btnfilter).length)) {
    $(".qd_search-filter-rst").removeClass("d-block")
    $(".qd_search-box").removeClass("ad-filter-open");
    var modelView = $(".react-autosuggest__suggestions-container--open")
    if (modelView.length === 0) {
      $(".qd_search-box").removeClass("is-focused");
    }
    if ($('.filter-count').css('display') === 'none') {
      $("#btn-filter").removeClass("active");
    }
    openflag = true;
  }
});

class AdvancedSearch extends React.Component {
  constructor(props) {
    super(props);
    this.getApi = getApi.bind(this);
    this.postUIlogs = postUIlogs.bind(this);
    this.postRecentSearch = postRecentSearch.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.changeCount = this.changeCount.bind(this);
    this.closeAdvancedFilter = this.closeAdvancedFilter.bind(this);
    this.handleSelected = this.handleSelected.bind(this);
    this.renderSuggestionsContainer = renderSuggestionsContainer.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.handleAdvancedFilter = this.handleAdvancedFilter.bind(this);
    this.convertData = this.convertData.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.getLastProcessing = getLastProcessing.bind(this);
    this.getMetadatas = getMetadatas.bind(this);
    let searchText = null;
    this.state = {
      nestedData: {},
      newData: {},
      showTreeView: false,
      initialSelection: {},
      isSearchHappened: false,
      errorOccurred: false,
      autoCompleteData: [],
      subString: null,
      searchCount: 0,
      fullData: [],
      isFilterOpen: false,
      isNoResult: false,
      searchText: searchText,
      filteredData: [],
      isRedirect: false,
      value: searchText,
      suggestions: [],
      preSelectedEnv: null,
      preSelectedDataset: this.props.preSelectedDataset,
      preSelectedDatasource: this.props.preSelectedDatasource,
      preSelectedAttribute: null,
      envCount: null,
      datasourceCount: null,
      datasetCount: null,
      attributeCount: null,
      metaData: null,
      filterData: null,
      integration_details: null,
      search_text: "",
      selectedEnv: null,
      inputData: this.props.inputData,
    }
  }

  closeAdvancedFilter() {
    this.setState({ isFilterOpen: false })
    openflag = false
    if (this.state.envCount === null) {
      $("#btn-filter").removeClass("active");
    }
    $(".qd_search-box").removeClass("ad-filter-open");
  }

  handleAdvancedFilter() {
    let isFilterOpen = !this.state.isFilterOpen
    if (isFilterOpen || openflag) {
      this.setState({ value: null });
      if (openflag) {
        $(".qd_search-filter-rst").addClass("d-block")
        this.setState({ isFilterOpen: true })
        openflag = false
      } else {
        this.setState({ isFilterOpen: isFilterOpen })
      }
      $("#filter-count").hide();
      $("#btn-filter").addClass("active");
      $(".qd_search-box").addClass("ad-filter-open");
    } else {
      $(".qd_search-box").removeClass("ad-filter-open");
      this.setState({ isFilterOpen: false });

      if (this.state.envCount === null) {
        $("#btn-filter").removeClass("active");
      }


    }
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };


  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    //suggestions: getSuggestions(value,this.state.autoCompleteData)
    this.setState({
      suggestions: formatMultiSection(value, this.state.autoCompleteData,this.props.selectedEnvId)
    });

  };

  renderSuggestion(suggestion, { query }) {
     if (suggestion.envId && suggestion.envId !== this.props.selectedEnvId) {
        return null;
      } 
    this.setState({ isFilterOpen: false })
    const suggestionText = suggestion.name;
    let uniqueKey = `${suggestion.envId}_${suggestion.datasourceId}_${suggestion.datasetId}_${suggestion.attributeId}`
    uniqueKey = uniqueKey.replace(undefined, "_")
    let icon = '';
    let connectionIcon = '';
    let path = '';
    switch (suggestion.type) {
      case "Recent":
        icon = '';
        break;
      case "Environment":
        icon = faServer;
        connectionIcon = '';
        path = suggestion.name;
        break;
      case "Datasource":
        icon = faDatabase;
        connectionIcon = suggestion.envName;
        path = suggestion.envName + "/" + suggestion.name;
        break;
      case "Dataset":
        icon = faLayerGroup;
        connectionIcon = suggestion.datasourceName;
        path = suggestion.envName + "/" + suggestion.datasourceName + "/" + suggestion.name;
        break;
      case "Attribute":
        icon = faTag;
        connectionIcon = suggestion.datasetName;
        path = suggestion.envName + "/" + suggestion.datasourceName + "/" + suggestion.datasetName + "/" + suggestion.name;
        break;
      default:
        icon = '';
        connectionIcon = '';
        break;
    }
      if (suggestion.type === "Recent" &&suggestion.envId && suggestion.envId !== this.props.selectedEnvId) {
        return null;
      }

    // Handle recency section here and return corresponding component
    if (suggestion.type === "Recent") {
      return (
        <div className={"suggestion-content"}>
          <p className="qd_autosuggest-option">
            <FontAwesomeIcon icon={faClock} />&nbsp;
            {this.getHighlightedText(normalizeChildDatasetName(suggestionText), query)}
            <i className="icon-close" title="Close"></i>
          </p>
        </div>
      );
    }

    // const renderTooltipText = (props) => (
    //   <span {...props}>
    //     {path}
    //   </span>
    // );
    let data = this.props.watchListMapping;

    // let count = 0
    // Object.keys(data).some((uniqueKey)=>{
    //   if(data[uniqueKey]['metadata_ids'].includes(suggestion.id)){
    //     count++
    //   }
    // });
    
    return (
      <>
        <div data-link={uniqueKey} className="datalink"
          style={{ textDecoration: "none" }}>
          <div className={"qd_autosuggest-content"}>
            <div className="qd_autosuggest-option">
              <RcTooltip
                placement="top"
                overlay={normalizeChildDatasetName(suggestionText)} // Tooltip content
                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
              >
                <div className="qd_autosuggest-option-inner">
                  <FontAwesomeIcon icon={icon} />
                  {this.getHighlightedText(normalizeChildDatasetName(suggestionText), query)} {/* Displayed text */}
                </div>
              </RcTooltip>
            </div>

            {connectionIcon.length > 0
              ?
              <RcTooltip
                placement="top"
                overlay={normalizeChildDatasetName(connectionIcon)}
                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
              >
                <span><FontAwesomeIcon icon={faCodeBranch} />
                  {normalizeChildDatasetName(connectionIcon)}
                </span>
              </RcTooltip>
              : ''
            }
          </div>
        </div>

        <div className="qd-watchlist-group">
          {data !== undefined && Object.keys(data).some(uniqueKey => data[uniqueKey]['metadata_ids'].includes(suggestion.id)) && (
            <>
              {/* {count > 3 &&
                <div className={`qd-watchlist-group__top ${isExpanded? "--is-expanded":""}`} onClick={this.toggleExpand}>
                  <label>
                    <i className="icon-toggle"></i>
                    <i className='mr-1'>
                      <svg className='d-block' xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor">
                        <path d="M330-490h300v-60H330v60Zm0-160h300v-60H330v60Zm447.23 498.23L627.92-345.85q-15.84-21.07-38.54-32.61Q566.69-390 540-390H180v-397.69Q180-818 201-839q21-21 51.31-21h455.38Q738-860 759-839q21 21 21 51.31v615.38q0 5.39-.69 10.46-.7 5.08-2.08 10.08ZM252.31-100Q222-100 201-121q-21-21-21-51.31V-330h360q12.31 0 22.73 5.46t17.96 15.39l154.54 202.3q-6.15 3.54-13.19 5.19Q715-100 707.69-100H252.31Z" />
                      </svg>
                    </i>
                    Watch list
                  </label>
                </div>
              } */}
              <div className="qd-watchlist-group__content">
                <ul className="qd-watchlist">
                  {Object.keys(data).map((uniqueKey) => {
                    if (data[uniqueKey]['metadata_ids'].includes(suggestion.id)) {
                      return (
                        <li key={uniqueKey} onClick={()=>{this.props.handleWatchlistChange(data[uniqueKey]['watchlist_name'],data[uniqueKey]['watchlist_id'])}}>
                          <span>
                            <i className='mr-1'>
                              <svg className='d-block' xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor">
                                <path d="M330-490h300v-60H330v60Zm0-160h300v-60H330v60Zm447.23 498.23L627.92-345.85q-15.84-21.07-38.54-32.61Q566.69-390 540-390H180v-397.69Q180-818 201-839q21-21 51.31-21h455.38Q738-860 759-839q21 21 21 51.31v615.38q0 5.39-.69 10.46-.7 5.08-2.08 10.08ZM252.31-100Q222-100 201-121q-21-21-21-51.31V-330h360q12.31 0 22.73 5.46t17.96 15.39l154.54 202.3q-6.15 3.54-13.19 5.19Q715-100 707.69-100H252.31Z" />
                              </svg>
                            </i>
                            {data[uniqueKey]['watchlist_name']}
                          </span>
                        </li>
                      );
                    }
                    return null;
                  })}
                </ul>
              </div>
            </>
          )}
        </div>

      </>
    );
  }

  getHighlightedText(text, highlight) {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return (parts.map((part, i) =>
      <span key={i}>
        {part.toLowerCase() === highlight.toLowerCase() ? <strong>{part}</strong> : part}
      </span>)
    );
  }

  changeCount(envCount, datasourceCount, datasetCount, attributeCount) {
    this.setState({
      envCount: envCount, datasourceCount: datasourceCount,
      datasetCount: datasetCount, attributeCount: attributeCount
    })
    openflag = true
  }


  applyFilter(type, envOption = null, datasourceOption = null, datasetOption = null, attributeOption = null) {
    // envName, datasourceName, datasetName, attributeName, envId, datasourceId,
    //   datasetId, attributeId, id, type, currentIndex = null,title
    // this.props.renderchartView();
   
    // let id = "#left-panel-div"
    // if(datasourceOption !== null && datasetOption !== null){
    //   id = id + datasourceOption["value"]  
    //   $(id).trigger("click");
    // }
    // if(datasetOption !== null){
    //   id = id + datasetOption["value"]  
    //   $(id).trigger("click");
    // }

    // if(attributeOption !== null){
    //   id = id + attributeOption["value"]  
    //   $(id).trigger("click");
    // }
    // $("#left-panel-div445").addClass("Addes");
    
    let nestedData = _.cloneDeep(this.state.nestedData)
    let newData = {}
    let initialSelection = { "type": type }
    let envId = null
    let envName = null
    let datasourceId = null
    let datasourceName = null
    let datasetId = null
    let datasetName = null
    let attributeId = null
    let attributeName = null
    if (envOption !== null) {
      envId = this.props.selectedEnvId;
      envName = envOption.label;
      initialSelection["envId"] = envId
      initialSelection["envName"] = envName
      newData[envId] = nestedData[envId]
      if (type === "Environment") {
        newData[envId]["isShow"] = true
      }
      newData[envId]["isOpen"] = true
    }
    if (datasourceOption !== null) {
      datasourceId = datasourceOption.value;
      datasourceName = datasourceOption.label;
      initialSelection["datasourceId"] = datasourceId
      initialSelection["datasourceName"] = datasourceName
      if (type === "Datasource") {
        newData[envId]["childNodes"][datasourceId]["isShow"] = true
      }
      if (!newData[envId]) {
        newData[envId] = {};
      }
      if (!newData[envId]["childNodes"]) {
        newData[envId]["childNodes"] = {};
      }
      if (!newData[envId]["childNodes"][datasourceId]) {
        newData[envId]["childNodes"][datasourceId] = {};
      }

      newData[envId]["childNodes"][datasourceId]["isOpen"] = true;
    }
    if (datasetOption !== null) {
      datasetId = datasetOption.value;
      datasetName = datasetOption.label;
      initialSelection["datasetId"] = datasetId
      initialSelection["datasetName"] = datasetName
      if (type === "Dataset") {
        newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isShow"] = true
      }
      if (!newData[envId]) {
        newData[envId] = {};
      }
      if (!newData[envId]["childNodes"]) {
        newData[envId]["childNodes"] = {};
      }
      if (!newData[envId]["childNodes"][datasourceId]) {
        newData[envId]["childNodes"][datasourceId] = {};
      }

      newData[envId]["childNodes"][datasourceId]["isOpen"] = true;
    }
    if (attributeOption !== null) {
      attributeId = attributeOption.value;
      attributeName = attributeOption.label;
      initialSelection["attributeId"] = attributeId
      initialSelection["attributeName"] = attributeName
      if (!newData[envId]) {
        newData[envId] = {};
      }
      if (!newData[envId]["childNodes"]) {
        newData[envId]["childNodes"] = {};
      }
      if (!newData[envId]["childNodes"][datasourceId]) {
        newData[envId]["childNodes"][datasourceId] = {};
      }

      newData[envId]["childNodes"][datasourceId]["isOpen"] = true;
      if (
        newData[envId] &&
        newData[envId].childNodes &&
        newData[envId].childNodes[datasourceId] &&
        newData[envId].childNodes[datasourceId].childNodes &&
        newData[envId].childNodes[datasourceId].childNodes[datasetId] &&
        newData[envId].childNodes[datasourceId].childNodes[datasetId].childNodes &&
        newData[envId].childNodes[datasourceId].childNodes[datasetId].childNodes[attributeId]
      ) {
        newData[envId].childNodes[datasourceId].childNodes[datasetId].childNodes[attributeId].isShow = true;
      }

}

    this.setState({
      newData: newData,
      initialSelection: initialSelection,
      isSearchHappened: true, searchText: "",
      preSelectedAttribute: attributeOption, preSelectedDataset: datasetOption,
      preSelectedDatasource: datasourceOption, preSelectedEnv: envOption
    });
    this.props.renderchartView(envName, datasourceName, datasetName, attributeName, envId, datasourceId, datasetId, attributeId, null, type,null,null)    
    if(attributeName !== undefined && attributeName !== null ){
      this.props.handleCloseAutoCompleteModal();
    }
  }
  
  handleSelected = (event, data) => {

    // let updateData = {}
    // updateData["datasetName"] = data["suggestion"]["name"]
    // updateData["datasourceId"] = Number(data["suggestion"]["datasourceId"])
    // updateData["datasourceName"] = data["suggestion"]["datasourceName"]
    // updateData["envId"] = Number(data["suggestion"]["envId"])
    // updateData["envName"] = data["suggestion"]["envName"]
    // updateData["id"] = Number(data["suggestion"]["id"])
    // updateData["name"] = data["suggestion"]["name"]
    // updateData["type"] = data["suggestion"]["type"]
    // let {datasetId, datasetName, datasourceId, datasourceName, attributeName, envId, envName, attributeId, type_} = updateData

    let name = data.suggestion.name
    let type = data.suggestion.type    
    if (name === "") {
      return
    }
    let initialSelection = data.suggestion
    $(".qd_search-box").addClass("has-btn-close")
    if (type === "Recent") {
      return
    }
    $(".filter-count").hide();
    $("#filtericon").show();
    $("#btn-filter").removeClass("active");
    $(".qd_search-box").removeClass("is-focused");

    this.setState({
      isRedirect: false, preSelectedEnv: null, preSelectedDatasource: null,
      preSelectedDataset: null, preSelectedAttribute: null, envCount: null,
      datasourceCount: null, datasetCount: null, attributeCount: null, subString: null
    });

    // this.setState({ value: null });
    $(".qd_search-box").removeClass("has-btn-close")
    this.convertData(initialSelection, this.state.fullData, this.state.nestedData, name, false)
  }

  convertData(initialSelection, fullData, nestedData, searchText, isRedirect) {

    let filteredData = [];
    let searchCount = 0;
    let name;
    if (initialSelection === null) {
      filteredData = fullData.filter(x => (x.name.includes(searchText) && x.type !== "Recent"))
      searchCount = filteredData.length
      if (filteredData.length === 0) {
        this.setState({
          newData: {},
          isSearchHappened: true,
          isRedirect: isRedirect,
          isNoResult: true,
          searchText: searchText
        });
        return
      }
      initialSelection = filteredData[0]
      name = initialSelection["name"]
    } else {
      if (initialSelection.type === "Recent") {
        filteredData = fullData.filter(x => (x.name === searchText && x.type !== "Recent"))
        initialSelection = filteredData[0]
      } else {
        filteredData = fullData.filter(x => x.name === initialSelection.name && x.id === initialSelection.id && x.type === initialSelection.type)
      }
      name = searchText
    }
    if (initialSelection.type === "Datasource") {
      initialSelection["datasourceName"] = name
    } else if (initialSelection.type === "Dataset") {
      initialSelection["datasetName"] = name
    } else if (initialSelection.type === "Attribute") {
      initialSelection["attributeName"] = name
    } else if (initialSelection.type === "Environment") {
      initialSelection["envName"] = name
    }
    let newData = {}
    nestedData = _.cloneDeep(nestedData)

    for (let i = 0; i < filteredData.length; i++) {
      let data = filteredData[i]
      let type = data["type"]

      let envId = this.props.selectedEnvId
      let datasourceId = data["datasourceId"]
      let datasetId = data["datasetId"]
      let attributeId = data["attributeId"]
      
      // Required changes to update the chart data
      let envName = data["envName"]
      let datasourceName = data["datasourceName"]
      let datasetName = data["datasetName"]
      let attributeName = data["attributeName"]
      this.props.renderchartView(envName, datasourceName, datasetName, attributeName, envId, datasourceId, datasetId, attributeId, null, initialSelection.type,null,null)    
      //
      // if(attributeName !== undefined && attributeName !== null ){
      this.props.handleCloseAutoCompleteModal();
      // } 

      // Trigger Left side panel tree.
      let id = "-left-panel-div-"
      if(type === "Datasource"){
        id  = "#" + type + id + "Datasource-" + datasourceId + "Datasource"
        $(id).trigger("click");
      }
      else if(type === "Dataset"){
        id  = "#" + type + id + "Dataset-" + datasetId + "Dataset"
        $(id).trigger("click");
      }
      else if( type === "Attribute"){
        id  = "#" + type + id + "Attribute-" + attributeId + "Attribute"
        $(id).trigger("click");        
      }



      if (!Object.keys(newData).includes(envId)) {
        newData[envId] = nestedData[envId]
        if (type === "Environment" || isRedirect) {
          newData[envId]["isShow"] = true
        }
        newData[envId]["isOpen"] = true
      }

      if (datasourceId !== undefined) {
        newData[envId]["childNodes"][datasourceId]["isOpen"] = true
        if (type === "Datasource" || isRedirect) {
          newData[envId]["childNodes"][datasourceId]["isShow"] = true
        }
      }

      if (datasetId !== undefined) {
        newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
        if (type === "Dataset" || isRedirect) {
          newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isShow"] = true
        }
      }

      if (attributeId !== undefined) {
        newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isOpen"] = true
        newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isShow"] = true
      }
    }
    let recentHistory = this.props.dataModule.recentHistory
    if (!recentHistory.includes(name)) {
      let tab = "realtime"
      this.postRecentSearch(name, tab);
      recentHistory.push(name);
      fullData.push({ "type": "Recent", "name": name });
      this.props.addRecentHistory(recentHistory);
    }
    this.setState({ isRedirect: isRedirect, searchCount: searchCount });


    this.setState({
      newData: newData,
      initialSelection: initialSelection,
      isSearchHappened: true,
      isNoResult: false,
      filteredData: filteredData,
      fullData: fullData,
      searchText: searchText
    });

  }


  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {

    this.setState({
      suggestions: [],
    });
  };
  // End Auto Complete

  //     preFetch() {
  //       let teamID = localStorage.getItem('team_id')
  //       let tenantData = { "tenant_id": teamID };

  // //      alert(1)
  //       // // Data Prefetch
  //       // // Single Api call and interating the result to get exact metadata values
  //      // if (!this.props.dataModule.preFetchMetaData) {
  //           preFetchMetaData(
  //               tenantData, this.props.addMetaData, this.props.addEnvironment,
  //               this.props.addEnvironmentDataSourceMapping, this.props.addDataSourceDataSetMapping,
  //               this.props.addDataSetAttributeMapping, this.props.setDataSet, this.props.setAttribute,
  //               this.props.setDataSource, this.props.setMlDataSource, this.props.addRelationship, this.props.addDataSource,
  //               this.props.addInfo, this.props.addLastProfilingTime, this.props.setStartDate, this.props.setEndDate, this.props.addDiscoveryStatus,
  //               this.props.addProcessingStatus, this.props.noIntegration
  //           );
  //       //}
  //   }

  componentDidMount() {
    let logoutPage = logoutPageRedirect()
    if (logoutPage) {
      return ''
    }
    let teamID = localStorage.getItem('team_id')
    let tenantData = { "tenant_id": teamID };

    this.getMetadatas();
    if (!this.props.dataModule.prefetchRecentHistory) {
          let searchTab = "discover"
          prefetchRecentHistory(tenantData, addRecentHistory, store, searchTab);
      }
    // this.prefetchRecentHistory(tenantData, addRecentHistory, store,retries=3)
    // this.prefetchRecentHistory();
    checkSessionForRedirection()
    this.getLastProcessing("getonlyprofiletime", "")
    // this.getApi("fetchDatasourceChartData");
    // Get Dataset Last processed time from API
    // this.getApi("fetchDatasetRefreshInfo");
    this.getApi("integrations");
  }


  componentDidCatch(error, info) {
    this.setState({ errorOccurred: true });
    this.postUIlogs(error, info);
  }

  // Before optimization
  // getData() {
  //   let metaData = this.state.metaData
  //   let nestedData = {}
  //   let fullData = []
  //   let envId = null
  //   let datasourceId = null
  //   let datasetId = null
  //   let prevEnvId = null
  //   let prevDatasourceId = null
  //   let prevDatasetId = null
  //   let attributeId = null
  //   let recentSearchData = this.props.dataModule.recentHistory
  //   for (let i = 0; i < recentSearchData.length; i++) {
  //     fullData.push({ "type": "Recent", "name": recentSearchData[i] });
  //   }


  //   // for (const [key, value] of Object.entries(metaData)) {
  //   //   let keySplit = key.split(METADATA_MAP_KEY_SEPARATOR)
  //   //   let valueSplit = value.split(METADATA_MAP_VALUE_SEPARATOR)
  //   //   envId = keySplit[0]
  //   //   datasourceId = keySplit[1]
  //   //   datasetId = keySplit[2]
  //   //   attributeId = keySplit[3]
  //   //   if (attributeId === undefined) {
  //   //     continue;
  //   //   }

  //   //   let envName = valueSplit[0]
  //   //   let datasourceName = valueSplit[1]
  //   //   let datasetName = valueSplit[2]
  //   //   datasetName = normalizeChildDatasetName(datasetName)
  //   //   let attributeName = valueSplit[valueSplit.length - 1]
  //   //   attributeName = normalizeAttributeName(attributeName);
  //   //   if (prevEnvId === null || prevEnvId !== envId) {
  //   //     fullData.push({ "name": envName, "envId": envId, "type": "Environment", "id": envId })
  //   //   }
  //   //   if (prevDatasourceId === null || prevDatasourceId !== datasourceId) {
  //   //     fullData.push({
  //   //       "name": datasourceName, "envName": envName, "id": datasourceId,
  //   //       "datasourceId": datasourceId, "type": "Datasource", "envId": envId
  //   //     })


  //   //   }
  //   //   if (prevDatasetId === null || prevDatasetId !== datasetId) {
  //   //     fullData.push({
  //   //       "name": datasetName, "id": datasetId, "datasetId": datasetId, "type": "Dataset", "envId": envId,
  //   //       "envName": envName, "datasourceId": datasourceId, "datasourceName": datasourceName
  //   //     })

  //   //   }


  //   //   fullData.push({
  //   //     "name": attributeName, "id": attributeId, "attributeId": attributeId, "type": "Attribute", "envId": envId, "envName": envName,
  //   //     "datasourceName": datasourceName, "datasourceId": datasourceId, "datasetId": datasetId, "datasetName": datasetName
  //   //   })

  //   //   if (!Object.keys(nestedData).includes(envId)) {
  //   //     nestedData[envId] = { "title": envName, "childNodes": {}, "type": "Environment", "id": envId }
  //   //     nestedData[envId]["childNodes"][datasourceId] = { "title": datasourceName, "childNodes": {}, "type": "Datasource", "id": datasourceId }
  //   //     nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId] = { "title": datasetName, "childNodes": {}, "type": "Dataset", "id": datasetId }
  //   //     nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId] = { "title": attributeName, "type": "Attribute", "id": attributeId }

  //   //   } else {
  //   //     if (!Object.keys(nestedData[envId]["childNodes"]).includes(datasourceId)) {
  //   //       nestedData[envId]["childNodes"][datasourceId] = { "title": datasourceName, "childNodes": {}, "type": "Datasource", "id": datasourceId }
  //   //       nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId] = { "title": datasetName, "childNodes": {}, "type": "Dataset", "id": datasetId }
  //   //       nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId] = { "title": attributeName, "type": "Attribute", "id": attributeId }
  //   //     } else {
  //   //       if (!Object.keys(nestedData[envId]["childNodes"][datasourceId]["childNodes"]).includes(datasetId)) {
  //   //         nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId] = { "title": datasetName, "childNodes": {}, "type": "Dataset", "id": datasetId }
  //   //         nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId] = { "title": attributeName, "type": "Attribute", "id": attributeId }
  //   //       } else {
  //   //         nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId] = { "title": attributeName, "type": "Attribute", "id": attributeId }
  //   //       }
  //   //     }
  //   //   }

  //   //   prevDatasourceId = datasourceId
  //   //   prevDatasetId = datasetId
  //   //   prevEnvId = envId




  //   // }

  //   // const metaData = {};
  //   // const fullData = [];

  //   const envMap = {};
  //   const datasourceMap = {};
  //   const datasetMap = {};
  //   const attributeMap = {};

  //   if(this.props.inputData === undefined || this.props.inputData === null ){
  //     return null
  //   }
  //   let inputData = this.props.inputData
  //   // Build maps for efficient lookup
  //   inputData.environments.forEach(env => envMap[env.value] = env.label);
  //   inputData.integrations.forEach(ds => datasourceMap[ds.value] = { label: ds.label, envId: ds.env_id });
  //   inputData.datasets.forEach(ds => datasetMap[ds.value] = { label: ds.label, integrationId: ds.integration_id });
  //   inputData.attributes.forEach(attr => attributeMap[attr.value] = { label: attr.label, datasetId: attr.data_set_id });

  //   // Process Attributes
  //   inputData.attributes.forEach(attribute => {
  //       const datasetData = datasetMap[attribute.data_set_id];
  //       if (!datasetData) {
  //           console.warn(`Dataset with ID ${attribute.data_set_id} not found.`);
  //           return; // Skip this attribute if dataset is missing
  //       }

  //       const datasourceData = datasourceMap[datasetData.integrationId];
  //       if (!datasourceData) {
  //           console.warn(`Datasource with ID ${datasetData.integrationId} not found.`);
  //           return; // Skip this attribute if datasource is missing
  //       }

  //       const envId = datasourceData.envId;
  //       const datasourceId = datasetData.integrationId;
  //       const datasetId = attribute.data_set_id;
  //       const attributeId = attribute.value;

  //       const envName = envMap[envId];
  //       const datasourceName = datasourceData.label;
  //       const datasetName = datasetData.label;
  //       const attributeName = attribute.label;

  //       // Build fullData
  //       if (!fullData.some(item => item.envId === envId && item.type === "Environment")) {
  //           fullData.push({ name: envName, envId: envId, type: "Environment", id: envId });
  //       }
  //       if (!fullData.some(item => item.datasourceId === datasourceId && item.type === "Datasource")) {
  //           fullData.push({ name: datasourceName, envName: envName, id: datasourceId, datasourceId: datasourceId, type: "Datasource", envId: envId });
  //       }
  //       if (!fullData.some(item => item.datasetId === datasetId && item.type === "Dataset")) {
  //           fullData.push({ name: datasetName, id: datasetId, datasetId: datasetId, type: "Dataset", envId: envId, envName: envName, datasourceId: datasourceId, datasourceName: datasourceName });
  //       }
  //       fullData.push({ name: attributeName, id: attributeId, attributeId: attributeId, type: "Attribute", envId: envId, envName: envName, datasourceName: datasourceName, datasourceId: datasourceId, datasetId: datasetId, datasetName: datasetName });

  //       // Build metaData
  //       if (!nestedData[envId]) {
  //           nestedData[envId] = { title: envName, childNodes: {}, type: "Environment", id: envId };
  //       }
  //       if (!nestedData[envId].childNodes[datasourceId]) {
  //           nestedData[envId].childNodes[datasourceId] = { title: datasourceName, childNodes: {}, type: "Datasource", id: datasourceId };
  //       }
  //       if (!nestedData[envId].childNodes[datasourceId].childNodes[datasetId]) {
  //           nestedData[envId].childNodes[datasourceId].childNodes[datasetId] = { title: datasetName, childNodes: {}, type: "Dataset", id: datasetId };
  //       }
  //       nestedData[envId].childNodes[datasourceId].childNodes[datasetId].childNodes[attributeId] = { title: attributeName, type: "Attribute", id: attributeId };
  //   });

  //   let searchText = this.state.searchText;
  //   let isRedirect = false
  //   let subString = null
  //   if (searchText !== undefined && searchText !== null && searchText !== "") {
  //     isRedirect = true
  //     subString = searchText
  //     this.convertData(null, fullData, nestedData, searchText, isRedirect)
  //     $(".qd_search-box").addClass("has-btn-close")
  //   }

  //   //let autoCompleteData = fullData.filter((v,i,a)=>a.findIndex(t=>(t.name === v.name && t.type===v.type))===i)

  //   this.setState({
  //     nestedData: nestedData,
  //     autoCompleteData: fullData,
  //     fullData: fullData,
  //     subString: subString,
  //     metaData: metaData
  //   });
  // }


  // After Optimization changes
  getData() {
    let metaData = this.state.metaData
    let nestedData = {}
    let fullData = []
    let recentSearchData = this.props.dataModule.recentHistory
    for (let i = 0; i < recentSearchData.length; i++) {
      fullData.push({ "type": "Recent", "name": recentSearchData[i] });
    }

    const envMap = {};
    const datasourceMap = {};
    // const datasetMap = {};
    // const attributeMap = {};
    const pipelineMap = {};

    if (this.props.inputData === undefined || this.props.inputData === null) {
      return null
    }
    let inputData = this.props.inputData
    // Build maps for efficient lookup
    if (inputData && inputData.pipelines) {
      // Build maps for efficient lookup

      inputData.integrations.forEach(ds => datasourceMap[ds.value] = { label: ds.label, envId: ds.env_id });
      inputData.pipelines.forEach(pipeline => pipelineMap[pipeline.value] = { label: pipeline.label, integrationId: pipeline.p_integration_id });

      // Process Pipelines
      inputData.pipelines.forEach(pipeline => {
        const datasourceData = datasourceMap[pipeline.p_integration_id];
        if (!datasourceData) {
          console.warn(`Datasource with ID ${pipeline.p_integration_id} not found.`);
          return; // Skip this pipeline if datasource is missing
        }

        const envId = datasourceData.envId;
        const datasourceId = pipeline.p_integration_id;
        const pipelineId = pipeline.value;

        const envName = envMap[envId] || "Environment"; // Default to "Environment" if not found
        const datasourceName = datasourceData.label;
        const pipelineName = pipeline.label;

        // Build fullData
        if (!fullData.some(item => item.envId === envId && item.type === "Environment")) {
          fullData.push({ name: envName, envId: envId, type: "Environment", id: envId });
        }
        if (!fullData.some(item => item.datasourceId === datasourceId && item.type === "Datasource")) {
          fullData.push({ name: datasourceName, envName: envName, id: datasourceId, datasourceId: datasourceId, type: "Datasource", envId: envId });
        }
        if (!fullData.some(item => item.pipelineId === pipelineId && item.type === "Pipeline")) {
          fullData.push({ name: pipelineName, id: pipelineId, pipelineId: pipelineId, type: "Pipeline", envId: envId, envName: envName, datasourceId: datasourceId, datasourceName: datasourceName });
        }

        // Build nestedData
        if (!nestedData[envId]) {
          nestedData[envId] = { title: envName, childNodes: {}, type: "Environment", id: envId };
        }
        if (!nestedData[envId].childNodes[datasourceId]) {
          nestedData[envId].childNodes[datasourceId] = { title: datasourceName, childNodes: {}, type: "Datasource", id: datasourceId };
        }
        if (!nestedData[envId].childNodes[datasourceId].childNodes[pipelineId]) {
          nestedData[envId].childNodes[datasourceId].childNodes[pipelineId] = { title: pipelineName, type: "Pipeline", id: pipelineId };
        }
      });
    } else if (inputData.environments && inputData.integrations && inputData.datasets && inputData.attributes) {
      // Existing logic for datasets and attributes
      const datasetMap = {};
      const attributeMap = {};

      inputData.environments.forEach(env => envMap[env.value] = env.label);
      inputData.integrations.forEach(ds => datasourceMap[ds.value] = { label: ds.label, envId: ds.env_id });
      inputData.datasets.forEach(ds => datasetMap[ds.value] = { label: ds.label, integrationId: ds.integration_id });
      inputData.attributes.forEach(attr => attributeMap[attr.value] = { label: attr.label, datasetId: attr.data_set_id });

      inputData.attributes.forEach(attribute => {
        const datasetData = datasetMap[attribute.data_set_id];
        if (!datasetData) {
          console.warn(`Dataset with ID ${attribute.data_set_id} not found.`);
          return;
        }

        const datasourceData = datasourceMap[datasetData.integrationId];
        if (!datasourceData) {
          console.warn(`Datasource with ID ${datasetData.integrationId} not found.`);
          return;
        }

        const envId = datasourceData.envId;
        const datasourceId = datasetData.integrationId;
        const datasetId = attribute.data_set_id;
        const attributeId = attribute.value;

        const envName = envMap[envId] || "Environment";
        const datasourceName = datasourceData.label;
        const datasetName = datasetData.label;
        const attributeName = attribute.label;

        if (!fullData.some(item => item.envId === envId && item.type === "Environment")) {
          fullData.push({ name: envName, envId: envId, type: "Environment", id: envId });
        }
        if (!fullData.some(item => item.datasourceId === datasourceId && item.type === "Datasource")) {
          fullData.push({ name: datasourceName, envName: envName, id: datasourceId, datasourceId: datasourceId, type: "Datasource", envId: envId });
        }
        if (!fullData.some(item => item.datasetId === datasetId && item.type === "Dataset")) {
          fullData.push({ name: datasetName, id: datasetId, datasetId: datasetId, type: "Dataset", envId: envId, envName: envName, datasourceId: datasourceId, datasourceName: datasourceName });
        }
        fullData.push({ name: attributeName, id: attributeId, attributeId: attributeId, type: "Attribute", envId: envId, envName: envName, datasourceName: datasourceName, datasourceId: datasourceId, datasetId: datasetId, datasetName: datasetName });

        if (!nestedData[envId]) {
          nestedData[envId] = { title: envName, childNodes: {}, type: "Environment", id: envId };
        }
        if (!nestedData[envId].childNodes[datasourceId]) {
          nestedData[envId].childNodes[datasourceId] = { title: datasourceName, childNodes: {}, type: "Datasource", id: datasourceId };
        }
        if (!nestedData[envId].childNodes[datasourceId].childNodes[datasetId]) {
          nestedData[envId].childNodes[datasourceId].childNodes[datasetId] = { title: datasetName, childNodes: {}, type: "Dataset", id: datasetId };
        }
        nestedData[envId].childNodes[datasourceId].childNodes[datasetId].childNodes[attributeId] = { title: attributeName, type: "Attribute", id: attributeId };
      });

    } else {
      console.warn("Input data structure not recognized.");
    }

    let searchText = this.state.searchText;
    let isRedirect = false
    let subString = null
    if (searchText !== undefined && searchText !== null && searchText !== "") {
      isRedirect = true
      subString = searchText
      this.convertData(null, fullData, nestedData, searchText, isRedirect)
      $(".qd_search-box").addClass("has-btn-close")
    }

    this.setState({
      nestedData: nestedData,
      autoCompleteData: fullData,
      fullData: fullData,
      subString: subString,
      metaData: metaData
    });
  }


  clearSearch() {
    $(".qd_search-box").removeClass("is-focused");
    this.setState({
      newData: {},
      searchText: "",
      subString: null, value: null,
      isNoResult: false,
      searchCount: 0, isRedirect: false, isSearchHappened: false, initialSelection: {}
    })
  }

  handleSearchChange = (event) => {
    let search_text = event.target.value.toLowerCase();
    this.setState({ search_text: search_text });

    let filteredEnv = this.state.filterData.environmentOptions.filter(env =>
      env.label.toLowerCase().includes(search_text)
    );

    this.setState({ filteredEnv: filteredEnv });
  };
  
  handleSelect = (env, index, latest_env_name) => {
    this.setState({
      selectedEnv: { ...env, color: env.label === latest_env_name ? '#4ca3ff' : colors[index % colors.length], },
    });
  };


  render() {
    let logoutPage = logoutPageRedirect()
    if (logoutPage) {
      return ''
    }
    // if ([false].includes(this.props.dataModule.datasetLastProcessInfoOver)) {
    //   return "";
    // }

    // let datasourceData = this.props.dataModule.discoverPageDataSource;
    // if (this.props.monitorModule.recencyPreview !== undefined) {
    //   datasourceData["Data Timeliness"] = this.props.monitorModule.recencyPreview.data;
    // }
    let { value, suggestions } = this.state;
value = typeof value === "string" ? value : "";


    let placeholder = 'Search for your data assets! Just start typing.'
    
    if(this.props.preSelectedDataset !== null && this.props.preSelectedDataset !== undefined && value === null){
      placeholder = this.props.preSelectedDataset["label"]
      value = this.props.preSelectedDataset["label"]
    }
    else if(this.props.preSelectedDatasource !== null && this.props.preSelectedDatasource !== undefined && value === null){
      placeholder = this.props.preSelectedAttribute["label"]
      value = this.props.preSelectedAttribute["label"]
    }


    // Autosuggest will pass through all these props to the input.
    let inputProps = {
      placeholder: placeholder,
      value:value,
      onChange: this.onChange,
    };
    const latestIntegration = this.state.integration_details !== null &&
      Object.values(this.state.integration_details)
        .sort((a, b) => new Date(b.created_time) - new Date(a.created_time))[0];

    const latest_env_name = latestIntegration?.env_name;
    const latest_env_id = latestIntegration?.env_id;

    return (

      <Modal show={this.props.autocompletemodal} size="lg" className="modal_search-autocomplete" onHide={this.props.handleCloseAutoCompleteModal}>
        <Modal.Body className="p-0">
          {/* <div className="qd-container">
            <div className="qd-body no-tabs">
              <div className="qd-tab__content" id={"Tab"}> */}
          <div className="qd_search-container">
            <div className="qd_search-box autocomplete">
              <Autosuggest
                multiSection={true}
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                inputProps={inputProps}
                alwaysRenderSuggestions={value !== undefined && value !== null && value.trim() === "" ? true : false}
                renderSectionTitle={renderSectionTitle}
                getSectionSuggestions={getSectionSuggestions}
                onSuggestionSelected={this.handleSelected}
                highlightFirstSuggestion={true}
                shouldRenderSuggestions={shouldRenderSuggestions}
                renderSuggestionsContainer={this.renderSuggestionsContainer}
                // preSelectedDataset = {this.props.preSelectedDataset}
                // preSelectedDatasource = {this.props.preSelectedDatasource}
              />
              {this.state.value !== null && this.state.value.trim() !== "" ? <button className="btn btn-clear" title="Clear" onClick={this.clearSearch}><i className="icon-close"></i></button> : ""}
              <div className="qd_search-bar-divider">
                <span>or</span>
              </div>
              <div className="qd-filtered_button">
                <button onClick={this.handleAdvancedFilter} id="btn-filter" className="btn btn-light-secondary">
                  <i id="filtericon"><svg xmlns="http://www.w3.org/2000/svg" fill="#0021a5" height="24" viewBox="0 0 24 24" width="24">
                    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg></i>
                  <span className="filter-count" style={{ display: "none" }}>3</span><span>Filters</span>
                </button>
              </div>
            </div>
            <div className={this.state.isFilterOpen ? "qd_search-filter-rst d-block" : "qd_search-filter-rst d-block"} data-select2-id="29">
              {this.state.isFilterOpen ?
                <DiscoverForm nestedData={this.state.nestedData}
                  applyFilter={this.applyFilter}
                  changeCount={this.changeCount}
                  closeAdvancedFilter={this.closeAdvancedFilter}
                  filterResultData={this.state.autoCompleteData}
                  preSelectedEnv={this.state.preSelectedEnv}
                  preSelectedDataset = {this.props.preSelectedDataset}
                  preSelectedDatasource = {this.props.preSelectedDatasource}
                  envCount={this.state.envCount} datasourceCount={Object.keys(this.props.preSelectedDatasource).length}
                  datasetCount={Object.keys(this.props.preSelectedDataset).length} attributeCount={this.state.attributeCount}
                  preSelectedAttribute={this.state.preSelectedAttribute}
                  selectedEnv={this.state.selectedEnv}
                  selectedEnvId={this.props.selectedEnvId}
                  latest_env_name={latest_env_name}
                  latest_env_id={latest_env_id}
                  handleCloseAutoCompleteModal = {this.props.handleCloseAutoCompleteModal}
                /> : ""}
            </div>
            <input type="hidden" id="zoomlevel" />
          </div>
          {/* </div>
            </div>
          </div> */}
        </Modal.Body>
      </Modal>

    );
  }
}


const mapStateToProps = state => {
  return state;
}

export default connect(mapStateToProps, {
  addRecentHistory,
  // fetchLastRefreshOfDatasets,
  storeDiscoverPageDataForDataSrc,
})(AdvancedSearch);
